import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Controller } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

$().ready(function () {
    if($('.page-content-project-detail').length) {

        // Swiper.use([Autoplay, Navigation, Pagination, Controller, EffectFade]);

        let mainImageSlider = new Swiper('.gallery-images-swiper', {
            modules: [Navigation, Controller, EffectFade],
            slidesPerView: 1,
            autoHeight: true,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });

        let thumbnailSlider = new Swiper('.gallery-images-thumbnails-swiper', {
            modules: [Controller],
            spaceBetween: 10,
            slidesPerView: 3,
            // watchSlidesProgress: true,
            slideToClickedSlide: true,
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: 4
                },
                1024: {
                    slidesPerView: 5
                }
            }
        });

        mainImageSlider.controller.control = thumbnailSlider;
        thumbnailSlider.controller.control = mainImageSlider;

        // mainImageSlider.on('slideChange', function () {
        //     thumbnailSlider.slideTo(mainImageSlider.activeIndex);
        // });
        //
        // thumbnailSlider.on('click', function (swiper, event) {
        //     mainImageSlider.slideTo(swiper.clickedIndex);
        //     setTimeout(() => {
        //         thumbnailSlider.slideTo(swiper.clickedIndex);
        //     }, 100);
        // });

    }
});
